import { render } from "./MappedSelect2Input.vue?vue&type=template&id=85dbe7e8"
import script from "./MappedSelect2Input.vue?vue&type=script&lang=js"
export * from "./MappedSelect2Input.vue?vue&type=script&lang=js"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__